import { useDrag } from "react-dnd";
import React, { useRef } from "react";

import { ITEM_TYPES } from "features/planner/planner.constants";
import CardContent from "features/planner/components/Card/CardContent";

const DraggableCard = ({
  card,
  cardId,
  slotNo,
  groupId,
  cardType,
  cardContainerId,
  cardContainerType,
}) => {
  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    item: {
      slotNo,
      groupId,
      cardType,
      id: cardId,
      cardContainerId,
      type: ITEM_TYPES.CARD,
      cardContainerType: cardContainerType,
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <CardContent
      ref={drag(ref)}
      card={card}
      cardId={cardId}
      groupId={groupId}
      isDragging={isDragging}
    />
  );
};

export default DraggableCard;
